import { Button } from '@leadsales/design-system/react';
import { useTranslation } from 'react-i18next';
import './ChatAccessNotice.styles.scss';
import { tChatModalGateStatus } from './useChatModalGate.hook';

export type tChatAccessNoticeProps = {
  status: Exclude<tChatModalGateStatus, 'ready'>;
  onRetry: () => void;
  /** The popup offers "Cerrar"; the main chat on /workspace/chat has nothing to close. */
  onClose?: () => void;
};

/** What stands in for a chat the gate has not cleared (AGI-761). */
export default function ChatAccessNotice(props: tChatAccessNoticeProps) {
  const { t } = useTranslation('chat/chat');

  if (props.status === 'checking') {
    return (
      <div className="ChatAccessNotice" role="status" aria-label={t('chatModal.checking')}>
        <span className="loading loading-spinner loading-md text-primary" />
      </div>
    );
  }

  return (
    <div className="ChatAccessNotice" role="alert">
      <p className="ChatAccessNotice__Title">{t(`chatModal.${props.status}.title`)}</p>
      <p className="ChatAccessNotice__Body">{t(`chatModal.${props.status}.body`)}</p>
      <div className="ChatAccessNotice__Actions">
        {props.status === 'failed' && (
          <Button size="sm" onClick={props.onRetry}>
            {t('chatModal.retry')}
          </Button>
        )}
        {props.onClose && (
          <Button size="sm" color="secondary" onClick={props.onClose}>
            {t('chatModal.close')}
          </Button>
        )}
      </div>
    </div>
  );
}
